import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPin, Mail, Phone } from "lucide-react";
import Logo from "@/branding/Logo";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-[var(--tr-deep-green)] text-white tr-grain mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10 relative">
        <div className="md:col-span-5">
          <div className="mb-5">
            <Logo variant="dark" size="lg" />
          </div>
          <h3 className="font-display text-3xl md:text-5xl font-extrabold leading-[0.95] tracking-tight max-w-md">
            {t("footer.tagline")}
          </h3>
          <p className="mt-6 text-white/70 max-w-md">{t("footer.about_text")}</p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--tr-citrus-yellow)] font-bold mb-4">
            {t("footer.ecosystem")}
          </div>
          <ul className="space-y-3 text-white/80">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-white tr-nolink">{t("nav.home")}</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-white tr-nolink">{t("nav.about")}</Link></li>
            <li><Link data-testid="footer-link-mosambi" to="/products/jalna-sweet-lime-mosambi" className="hover:text-white tr-nolink">{t("nav.sweet_lime")}</Link></li>
            <li><Link data-testid="footer-link-farmer" to="/farmer-network" className="hover:text-white tr-nolink">{t("nav.farmer_network")}</Link></li>
            <li><Link data-testid="footer-link-fpo" to="/fpo-partnership" className="hover:text-white tr-nolink">{t("nav.fpo_partnership")}</Link></li>
            <li><Link data-testid="footer-link-buyers" to="/buyers" className="hover:text-white tr-nolink">{t("nav.buyers")}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.24em] text-[var(--tr-citrus-yellow)] font-bold mb-4">
            {t("footer.reach_us")}
          </div>
          <ul className="space-y-4 text-white/85">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 shrink-0" /><span>{t("footer.office_line1")} {t("footer.office_line2")}</span></li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-1 shrink-0" /><a href="mailto:truerootsagro@gmail.com" className="hover:text-white">truerootsagro@gmail.com</a></li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-1 shrink-0 opacity-70" /><a href="mailto:info@truerootsagro.in" className="hover:text-white text-white/80">info@truerootsagro.in</a></li>
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-1 shrink-0" /><a href="tel:+919326721459" className="hover:text-white">+91 93267 21459</a></li>
          </ul>
          <Link to="/contact" data-testid="footer-cta" className="tr-pill-btn tr-btn-zest mt-6">
            {t("footer.start_conversation")}
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-white/60">
          <p>© {new Date().getFullYear()} TrueRoots Agro Foods LLP. {t("footer.rights")}</p>
          <div className="flex items-center gap-6">
            <span>{t("footer.poshan_vatika")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
